import styled from 'styled-components';
import { Button } from '@elementary/common-ui/components';
import { ENVIRONMENT_DRAWER_ACTIONS } from './constants';

const ConfigureButton = styled(Button)`
  && {
    width: 100%;
  }
`;

type Props = {
  onConfigureClick: () => void;
};

const SourceContentSection = ({ onConfigureClick }: Props) => (
  <ConfigureButton variant="outlined" onClick={onConfigureClick}>
    {ENVIRONMENT_DRAWER_ACTIONS.configureAssetSources}
  </ConfigureButton>
);

export default SourceContentSection;
